import fetch from '@/services/fetch'
import { bidang, jabatan } from '@/config/api'

export const getBidangs = async () => await fetch.get(bidang)

export const getJabatan = async () => await fetch.get(jabatan)
